import z from 'zod';
/**
 * Step evaluation statuses persisted on a case calendar.
 * Aligned with CalendarStepEvaluationStatus from calendar.
 */
export const CASE_CALENDAR_STEP_STATUSES = [
    'calculated',
    'cleared_incoherent',
    'input',
    'missing_input',
    'override',
    'skipped',
];
export const caseCalendarStepStatusValue = z.enum(CASE_CALENDAR_STEP_STATUSES);
const caseCalendarParameterValue = z.union([
    z.boolean(),
    z.number(),
    z.string(),
]);
export const caseCalendarStepSchema = z.object({
    date: z.date().optional(),
    didApplyMaxConstraint: z.boolean(),
    didApplyWeekendAdjustment: z.boolean(),
    maxConstraintDate: z.date().optional(),
    status: caseCalendarStepStatusValue,
    stepId: z.string().min(1),
});
/**
 * Persisted calendar snapshot on a legal case (dossier):
 * user inputs (A) + engine evaluation (B).
 */
export const caseCalendarSchema = z.object({
    dates: z.record(z.string(), z.date()),
    inputDates: z.record(z.string(), z.date()),
    parameters: z.record(z.string(), caseCalendarParameterValue),
    steps: z.array(caseCalendarStepSchema),
});
export const parseCaseCalendar = (value) => caseCalendarSchema.parse(value);
export const isCaseCalendar = (value) => caseCalendarSchema.safeParse(value).success;
export const hasIncompleteCaseCalendarSteps = (calendar) => calendar.steps.some(step => step.status === 'missing_input');
/**
 * Build a CaseCalendar from generate inputs + engine result.
 */
export function buildCaseCalendar(input) {
    const parameters = input.parameters === undefined
        ? {}
        : { ...input.parameters };
    return parseCaseCalendar({
        dates: { ...input.engineResult.dates },
        inputDates: { ...input.inputDates },
        parameters,
        steps: input.engineResult.steps.map(step => ({
            date: step.date,
            didApplyMaxConstraint: step.didApplyMaxConstraint,
            didApplyWeekendAdjustment: step.didApplyWeekendAdjustment,
            maxConstraintDate: step.maxConstraintDate,
            status: step.status,
            stepId: step.stepId,
        })),
    });
}
//# sourceMappingURL=case-calendar.js.map